import PropTypes from 'prop-types';

import { getContent } from '@/utils/helper';
import { analytics, getClickHeaderNavigation } from '@/utils/analytics';

import Icon from '@/atoms/Icon/Icon';
import Text from '@/atoms/Text/Text';
import { CtaWrapper } from '@/molecules/CTA/index';

function NavigationWithSubMenu({
  entries,
  navigationMenu,
  closeNavigation,
  style,
  reloadPage,
}) {
  const handleMenuClick = (e, url) => {
    analytics({
      window,
      document,
      detail: getClickHeaderNavigation(e, { url }),
    });
    closeNavigation();
    if (reloadPage) {
      window.location.href = url;
    }
  };

  return (
    <ul
      className={`aaco-menus nav-menu__items justify-center lg:items-center gap-x-10 lg:order-2 w-full ${style}`}
    >
      {navigationMenu.length > 0 &&
        navigationMenu.slice(0, navigationMenu.length - 1).map((m, index) => {
          if (!m?.name) return;

          return (
            <li
              key={index}
              className={`aaco-navigation__link py-[15px] lg:py-0`}
            >
              {m.subNavigation && m.subNavigation.length > 0 ? (
                <details open className="nav-menu__items__has_submenu group">
                  <summary className="flex items-center gap-x-[5.63px] lg:py-0 cursor-pointer justify-between lg:justify-start">
                    <CtaWrapper
                      url={m?.url}
                      page={m?.pageUrl}
                      onClick={(e) =>
                        handleMenuClick(e, m?.url ?? `/${m?.pageUrl}`)
                      }
                      classNames={'no-text-underline'}
                      reloadPage={isDD}
                    >
                      <Text tag="body" style={`text-white`}>
                        {m.name}
                      </Text>
                    </CtaWrapper>
                    <Icon
                      name="chevron-down"
                      height={8.75}
                      width={4.38}
                      className={`w-[10px] h-[10px] text-white lg:translate-y-[1.5px] group-open:rotate-180 transition-transform lg:group-open:rotate-0 lg:group-hover:rotate-180`}
                    />
                  </summary>
                  <div className="mt-[15px] lg:mt-0 border-l-2 border-actual-dd-gold lg:border-none lg:hidden lg:group-hover:block lg:absolute lg:origin-top lg:pt-2">
                    <ul className="px-[20px] lg:px-[15px] lg:w-[216px] lg:bg-white lg:rounded-[8px] lg:shadow-dropdown">
                      {m.subNavigation.map((subitem, index) => {
                        const subitemFields = getContent(
                          subitem.sys.id,
                          entries
                        )?.fields;
                        return (
                          <li
                            key={`sub-${index}`}
                            className="pt-4 pb-[14px] lg:border-b lg:border-grey-dd last:border-none"
                          >
                            <CtaWrapper
                              url={subitemFields.url}
                              page={subitemFields.pageUrl}
                              onClick={(e) =>
                                handleMenuClick(
                                  e,
                                  subitemFields.url ??
                                    `/${subitemFields.pageUrl}`
                                )
                              }
                              classNames={'no-text-underline'}
                            >
                              <Text
                                tag="body"
                                style={`text-white lg:text-black`}
                              >
                                {subitemFields.name}
                              </Text>
                            </CtaWrapper>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </details>
              ) : (
                <CtaWrapper
                  url={m?.url}
                  page={m?.pageUrl}
                  onClick={(e) =>
                    handleMenuClick(e, m?.url ?? `/${m?.pageUrl}`)
                  }
                  classNames={'no-text-underline'}
                >
                  <Text tag="body" style={`text-white`}>
                    {m.name}
                  </Text>
                </CtaWrapper>
              )}
            </li>
          );
        })}
    </ul>
  );
}

NavigationWithSubMenu.propTypes = {
  entries: PropTypes.array,
  navigationMenu: PropTypes.array,
  closeNavigation: PropTypes.func,
  style: PropTypes.string,
  reloadPage: PropTypes.bool,
};

NavigationWithSubMenu.defaultProps = {
  entries: [],
  navigationMenu: [],
  closeNavigation: () => {},
  style: '',
  reloadPage: false,
};

export default NavigationWithSubMenu;
